import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "@/context/Shop";
import { ProductGrid } from "@/components/store/ProductCard";
import { useSeo } from "@/hooks/useSeo";

export default function Wishlist() {
  const { wishlist, customer } = useShop();
  useSeo("Your wishlist", "The pieces you have saved for later.");
  const items = (wishlist.items || []).filter((i) => i.available).map((i) => i.product);
  return (
    <div className="container-lux py-10" data-testid="wishlist-page">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
        <div>
          <h1 className="font-display text-5xl font-medium">Wishlist</h1>
          <p className="text-sm text-muted-foreground mt-2">{wishlist.count} {wishlist.count === 1 ? "piece" : "pieces"} saved {customer ? "to your account" : "on this device"}.</p>
        </div>
        {!customer && <Link to="/account/login" className="text-[12px] uppercase tracking-[0.14em] link-lux" data-testid="wishlist-signin-link">Sign in to save across devices</Link>}
      </div>
      {items.length === 0 ? (
        <div className="py-24 text-center" data-testid="wishlist-empty">
          <Heart className="h-10 w-10 mx-auto text-muted-foreground" strokeWidth={1.1} />
          <h2 className="font-display text-3xl mt-6">No favourites yet</h2>
          <p className="text-sm text-muted-foreground mt-3">Tap the heart on any product to save it here for later.</p>
          <Link to="/new-arrivals" className="btn-ink mt-8 inline-flex" data-testid="wishlist-empty-shop-link">Explore new in</Link>
        </div>
      ) : <ProductGrid items={items} testid="wishlist-grid" />}
    </div>
  );
}
